import type { SlideProps } from "@/engine/app/offsite-config";

const TOOLS = [
  {
    title: "RPA — der Roboter",
    text: "Klickt und tippt nach festem Drehbuch, wie ein sehr schneller Kollege am Bildschirm. Perfekt für immer gleiche Abläufe. Lernt nichts dazu.",
  },
  {
    title: "ML — der Mustererkenner",
    text: "Lernt aus vielen Beispielen und sagt voraus: Lastprofile, Ausfallwahrscheinlichkeiten, Verbrauchsprognosen. Rechnet mit Zahlen, nicht mit Sprache.",
  },
  {
    title: "LLM — das Sprachmodell",
    text: "Versteht und erzeugt Sprache: liest Anträge, fasst zusammen, formuliert Antworten, schreibt Code. Das steckt hinter ChatGPT und Claude.",
  },
];

export function Slide06RpaMlLlm(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Die drei Begriffe sortiert</div>
        <h1 className="deck-title rise rise-2">
          RPA · ML · LLM — <br />
          <span className="accent">wer macht was?</span>
        </h1>
        <p className="deck-sub rise rise-3">
          Drei Werkzeuge, drei völlig verschiedene Stärken.
        </p>
      </header>

      <div className="deck-cols2" style={{ gridTemplateColumns: "repeat(3, 1fr)", gap: 20 }}>
        {TOOLS.map((t, i) => (
          <div key={t.title} className={`col-card rise rise-${i + 4}`}>
            <div className="col-eyebrow">0{i + 1}</div>
            <h4>{t.title}</h4>
            <p>{t.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
